export function toNumericUserId(input: string | number): number {
  if (typeof input === 'number') return input
  const n = parseInt(input, 10)
  if (!Number.isNaN(n)) return n
  // Deterministic non-negative 32-bit hash
  let hash = 0
  for (let i = 0; i < input.length; i++) {
    hash = (hash * 31 + input.charCodeAt(i)) | 0
  }
  // Ensure positive and non-zero
  hash = hash >>> 0
  if (hash === 0) hash = 1
  return hash
}

export default { toNumericUserId }
